import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { UFOExperience } from '@atlassian/ufo';

/**
 * An extension of the UFOExperience class but it gets fired only once per UI session.
 */
export var UFOExperienceOneTime = /*#__PURE__*/function (_UFOExperience) {
  _inherits(UFOExperienceOneTime, _UFOExperience);
  var _super = _createSuper(UFOExperienceOneTime);
  function UFOExperienceOneTime() {
    _classCallCheck(this, UFOExperienceOneTime);
    return _super.apply(this, arguments);
  }
  _createClass(UFOExperienceOneTime, [{
    key: "start",
    value: function start() {
      if (!this.startInvoked) {
        this.startInvoked = true;
        return _get(_getPrototypeOf(UFOExperienceOneTime.prototype), "start", this).call(this);
      }
      return Promise.resolve();
    }
  }]);
  return UFOExperienceOneTime;
}(UFOExperience);